import httpFactory from "../utils/httpClient";

export const loadConfigService = action => httpFactory().get("config")